import React from 'react';
import ToggleSwitch from '../../../Components/ToggleSwitch';

interface ReeferFieldsProps {
    toggles: any;
    handleToggleChange: (key: string, value: boolean) => void;
}

const ReeferFields: React.FC<ReeferFieldsProps> = ({ toggles, handleToggleChange }) => {
    return (
        <div className="row g-3 align-item-center mb-3">
            <div className="col-md-4">
                <ToggleSwitch
                    label="Capture Reefer Preset Value"
                    labelStyle="ms-2 fw-600"
                    checked={toggles.presetValue}
                    onChange={(value: any) => handleToggleChange("presetValue", value)} />
            </div>
            <div className="col-md-4">
                <ToggleSwitch
                    label="Capture Reefer Hours"
                    labelStyle="ms-2 fw-600"
                    checked={toggles.hoursValue}
                    onChange={(value: any) => handleToggleChange("hoursValue", value)} />
            </div>
            <div className="col-md-4">
                <ToggleSwitch
                    label="Capture Reefer Temperature"
                    labelStyle="ms-2 fw-600"
                    checked={toggles.temperatureValue}
                    onChange={(value: any) => handleToggleChange("temperatureValue", value)} />
            </div>
        </div>
    );
};

export default ReeferFields;
